import { render, staticRenderFns } from "./SharedVideoModal.vue?vue&type=template&id=4f2324e2"
import script from "./SharedVideoModal.vue?vue&type=script&lang=js"
export * from "./SharedVideoModal.vue?vue&type=script&lang=js"
import style0 from "./SharedVideoModal.vue?vue&type=style&index=0&id=4f2324e2&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2324e2')) {
      api.createRecord('4f2324e2', component.options)
    } else {
      api.reload('4f2324e2', component.options)
    }
    module.hot.accept("./SharedVideoModal.vue?vue&type=template&id=4f2324e2", function () {
      api.rerender('4f2324e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SharedVideo/Modal/SharedVideoModal.vue"
export default component.exports